export const NovaWallet = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 324 324"
  >
    <defs>
      <radialGradient
        id="a"
        cx="8.15"
        cy="306.07"
        r="323.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d7d3e9" />
        <stop offset=".18" stopColor="#a9b0ea" />
        <stop offset=".39" stopColor="#7a8ceb" />
        <stop offset=".54" stopColor="#5d76ec" />
        <stop offset=".63" stopColor="#526eec" />
        <stop offset="1" stopColor="#397dcd" />
      </radialGradient>
    </defs>
    <rect width="324" height="324" rx="84.12" fill="url(#a)" />
    <path
      d="M275 166.67v3c-18.44 2.94-58 9.77-77.52 17.22a26.53 26.53 0 00-15.19 15.06c-7.45 19.39-14.37 59.21-17.31 77.74h-6c-2.94-18.53-9.86-58.35-17.31-77.74a26.56 26.56 0 00-15.19-15.06C107 179.42 67.44 172.59 49 169.65v-6c18.44-2.94 58-9.77 77.52-17.22a26.53 26.53 0 0015.19-15.06C149.16 112 156.08 72.2 159 53.67h6c2.94 18.53 9.86 58.35 17.31 77.74a26.56 26.56 0 0015.19 15.06c19.48 7.45 59.08 14.28 77.52 17.22z"
      fill="#fff"
    />
  </svg>
);

export default NovaWallet;
